var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _setup.vmodel,
          expression: "vmodel",
        },
      ],
      staticClass: "custom-select",
      attrs: { name: _vm.name },
      on: {
        change: function ($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function (o) {
              return o.selected
            })
            .map(function (o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _setup.vmodel = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        },
      },
    },
    [
      _c("option", { attrs: { value: "", disabled: "", selected: "" } }, [
        _vm._v(_vm._s(_vm.placeholder)),
      ]),
      _vm._v(" "),
      _vm._l(_vm.options, function ({ value, text }, index) {
        return _c(
          "option",
          { key: `dropdown-${_vm.name}-${index}`, domProps: { value: value } },
          [_vm._v("\n        " + _vm._s(text) + "\n    ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }